(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/voucher-redeem/assets/javascripts/utils.js') >= 0) return;  svs.modules.push('/components/tur/voucher-redeem/assets/javascripts/utils.js');
"use strict";

const INVALID_VOUCHER = 'Koden är felaktigt inmatad, förbrukad eller utgången. Kontrollera koden och försök igen.';
setGlobal('svs.tur.voucherRedeem.utils', {
  formattedVoucherCode: code => code && code.replace(/ /g, '').replace(/(.{3})/g, '$1 ').trim().toUpperCase(),
  validators: value => {
    let isValid = true;
    let errorMessage = '';
    const code = value.replaceAll(' ', '');
    if (code.length !== 12) {
      isValid = false;
      errorMessage = INVALID_VOUCHER;
    }
    return {
      isValid,
      errorMessage
    };
  },
  errorMessages: {
    INVALID_VOUCHER
  }
});

 })(window);